import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { CoreServices } from "@/components/site/CoreServices";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Specialist } from "@/components/site/Specialist";
import { PricingPreview } from "@/components/site/PricingPreview";
import { Contact } from "@/components/site/Contact";

export default function Home() {
  return (
    <div className="relative bg-[#08090B]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <CoreServices />
        <WhyChooseUs />
        <Specialist />
        <PricingPreview />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
